import type { ISegment } from "@repo/baseCloud";

import { GridFiltersController } from "@repo/baseCloud";
import { FilterDropdown } from "@repo/ui";
import { useQuery } from "@tanstack/react-query";
import { ReactNode, useCallback, useMemo } from "react";

import { QUERY_KEYS } from "../api/queries";

interface Props {
	value: number[];
	changeHandler: (value: number[], id: string) => void;
	label?: ReactNode;
	filters?: ISegment;
	id?: string;
	/** When true, only active representatives are returned by the reps endpoint */
	onlyActiveReps?: boolean;
}

export function RepsDropdown(props: Props) {
	const { filters = {}, id = "reps", onlyActiveReps } = props;
	const repFilters = useMemo(
		() => ({
			brands: filters.brandIds,
			channels: filters.channelIds,
			marketers: filters.marketerIds,
			states: filters.stateIds,
			branches: filters.branchIds,
			showInactiveOffices: filters.showInactiveOffices,
			onlyActiveReps,
		}),
		[filters, onlyActiveReps],
	);

	const repsQuery = useQuery({
		queryKey: [QUERY_KEYS.Components.RepsDropdown, repFilters],
		queryFn: () => GridFiltersController.getReps(repFilters),
	});

	const changeHandler = useCallback((v: number[]) => props.changeHandler(v, id), [props.changeHandler, id]);

	return (
		<FilterDropdown
			{...props}
			id={id}
			allOption
			values={repsQuery.data ?? []}
			loaded={!repsQuery.isLoading}
			changeHandler={changeHandler}
			objectName="Representatives"
			fullLength
			isMulti
		/>
	);
}
